// extracted by mini-css-extract-plugin
export default {"status":"status__status-C2Uhu"};